import type { TimerTheme } from './timerThemes';

export const TIMER_LABEL_KEYS = ['statLabel', 'blindsLabel', 'lateReg'] as const;

export function unifyTimerLabels(
  fontSizes: Record<string, number>,
  theme: TimerTheme,
): Record<string, number> {
  const value =
    TIMER_LABEL_KEYS.map((key) => fontSizes[key]).find(
      (size) => typeof size === 'number' && Number.isFinite(size) && size >= 6 && size <= 400,
    ) ?? (theme === 'pokerfans' ? 25 : 20);
  return { ...fontSizes, statLabel: value, blindsLabel: value, lateReg: value };
}
